if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.webDrawBtn = this.querySelector('.web-drawer-btn');
        this.dateUtils = new DateUtils();
        this.productUtils = new ProductUtils(this.dataset.handle)

      }

      connectedCallback() {
        this.addToRecentlyViewed();
        this.checkIfComingSoon();
        this.handleAccordions();
      }


      handleAccordions() {
        const accordions = Array.from(this.querySelectorAll('#main-product-grid .product__accordion details ') || [])
        accordions.forEach(el => {
          el.addEventListener('click', () => {
            accordions.forEach(subEl => {
              if (subEl.getAttribute('id') !== el.getAttribute('id')) {
                subEl.removeAttribute('open')
              }
            })
          })
        })
      }

      showSizes() {
        this.querySelector('.pdp-details').classList.remove('hide');
        this.querySelector('#desktop-variant-picker').classList.remove('hide');
        this.querySelector('#mobile-variant-picker').classList.remove('hide');

        this.webDrawBtn.classList.add('hide');
      }

      async checkIfComingSoon() {
        const comingSoonDate = this.getAttribute('data-coming-soon-date');
        if (!comingSoonDate) return

        const currentDate = this.dateUtils.getCurrentUTCDate();
        const countDownDate = this.dateUtils.formatDate(comingSoonDate);
        const differenceMs = countDownDate - currentDate;

        this.webDrawBtn = this.querySelector('.web-drawer-btn');

        if (Math.sign(differenceMs) === -1) {
          await this.handleCountdownEnded();
          return;
        }

        this.handleHideEls()
        this.changeWebDrawCounter(countDownDate);

        setInterval(() => {
          this.changeWebDrawCounter(countDownDate);
        }, 1000);
      }

      async handleCountdownEnded() {
        const productAvailable = await this.productUtils.checkIfProductAvailable();
        if (productAvailable) {
          this.showSizes();
          return
        }

        this.webDrawBtn.innerHTML = window.productForm.webDrawAvailableFewSeconds
        this.handleHideEls()
        setInterval(async () => {
          const isAvailable = await this.productUtils.checkIfProductAvailable();
          if (isAvailable) {
            window.location.reload();
          }
        }, 5000);
      }


      handleHideEls() {
        this.webDrawBtn.classList.remove('hide');
        this.querySelector('.desktop-wishlist-btn').classList.add('hide')
        this.querySelector('.pdp-details').classList.remove('hide');
      }

      changeWebDrawCounter(countDownDate) {
        this.querySelectorAll('.web_draw_message')?.forEach((el) => el.classList.remove('twcss-hidden'));
        const currentDate = this.dateUtils.getCurrentUTCDate();
        const differenceMs = parseInt(countDownDate - currentDate);

        if (Math.sign(differenceMs) === -1) {

          this.webDrawBtn.innerHTML = window.productForm.webDrawAvailableFewSeconds;
          window.location.reload()
          return
        }

        const timeObj = this.dateUtils.getTimeObjFromMS(differenceMs);
        const times = this.dateUtils.getTimeString(timeObj);

        this.webDrawBtn.innerHTML = `${window.productForm.webDrawAvailable}  <span class='countdown-time'>( ${times} )</span> `;
      }

      addToRecentlyViewed() {
        const recentlyViewed = JSON.parse(localStorage.getItem('RecentlyViewedSJ')) || [];
        const handle = this.getAttribute('data-url').replace('/products/', '');

        if (!recentlyViewed.find((string) => string === handle)) {
          recentlyViewed.push(handle);
        }

        localStorage.setItem('RecentlyViewedSJ', JSON.stringify(recentlyViewed));
      }

      disconnectedCallback() {}
    }
  );
}
